// extracted by mini-css-extract-plugin
module.exports = {"waves":"wave-scroller_waves__SCuyb","parallax":"wave-scroller_parallax__1TUOT"};